import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const SeoStreamPage = lazy(
  () =>
    import('./SeoStreamPage.eager').then(mod => ({
      default: mod.SeoStreamPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
